<template>
    <div class="card-component sucesos-pestana">
        <DxTabs :items="pestanas" @itemClick="onItemClick" :selectedIndex="0" :visible="hayAlMenosUnaPestana">
        </DxTabs>
        <SignalsViewer :files="ficheros" :mostrarNombresFichero="false" v-if="hayAlMenosUnaPestana"></SignalsViewer>
        <span class="no-ficheros" v-else><i class="fa-solid fa-circle-info"></i>
            {{ $t('sucesos.pestanas_ficheros_medida.no_hay_ficheros') }}
        </span>
    </div>
</template>

<script setup lang="ts">
import { DxTabs } from 'devextreme-vue';
import { useIntl } from '@services/i18n';
import { useApi } from '@/.shared/.api/integration';
import { computed, onMounted, ref, watch } from 'vue';
import type { FicheroMedidaDetalleModel } from '@/.shared/.api';
import { type Item, type ItemClickEvent } from 'devextreme/ui/tabs';
import SignalsViewer from '@/components/senyales/SignalsViewer.vue';
import { toastError } from '@/.shared/services/notification-service';
import { getNombreFicheroSinExtension } from '@/.shared/helpers/file-helper';

const props = defineProps<{ ficherosMedidaProp: FicheroMedidaDetalleModel[] }>();
const ficherosMedida = computed(() => props.ficherosMedidaProp);

const api = useApi();
const intl = useIntl();

const ficheros = ref<{ cfgFile: File, datFile: File } | null>(null);
const pestanas = ref<(Item & { item: FicheroMedidaDetalleModel })[]>();
const hayAlMenosUnaPestana = computed(() => (pestanas?.value?.length ?? 0) > 0);
const tabsClasses = computed(() => [
    'widget-wrapper'
]);

onMounted(async () => {
    watch(() => (props.ficherosMedidaProp), async (nuevosFIcherosMedida: FicheroMedidaDetalleModel[]) => {
        await crearPestanas();
    }, { immediate: true });
});

async function crearPestanas(): Promise<void> {
    pestanas.value = ficherosMedida.value.select(x => {
        return {
            icon: 'fa-solid fa-file',
            // text: standardFormatDate(x.FechaDisparo, x.CodigoZonaHorariaInstalacion)!, item: x,
            // text: `${getNombreFichero(x.RutaFicheroCfg)}.\r\n${getNombreFichero(x.RutaFicheroDat)}.\r\n${getNombreFichero(x.RutaFicheroHdr)}`,
            text: `CFG, DAT: ${getNombreFichero(x.RutaFicheroDat)}`,
            item: x
        };
    }).toArray();
    if (ficherosMedida.value.any())
        await cargarFicherosMedida(pestanas.value[0].item.Id);
};

async function onItemClick(e: ItemClickEvent): Promise<void> {
    const ficheroMedida = e.itemData!.item as FicheroMedidaDetalleModel;
    await cargarFicherosMedida(ficheroMedida.Id);
}

async function cargarFicherosMedida(idFicheroMedida: number) {
    try {
        const ficheroMedidaCfg: File = await api.callStandardApi("ficheroMedidaDownload", { isFile: true }, idFicheroMedida, true);
        const ficheroMedidaDat: File = await api.callStandardApi("ficheroMedidaDownload", { isFile: true }, idFicheroMedida, false);
        ficheros.value = {
            cfgFile: ficheroMedidaCfg,
            datFile: ficheroMedidaDat,
        }
    } catch (error) {
        toastError(intl.i18n.t('sucesos.pestanas_ficheros_medida.mensaje_error_obtener_ficheros'));
        console.error(error);
    }
}

function getNombreFichero(rutaFichero: string): string { // ficheros-medida:20240925_205748.cfg    
    var url = new URL(rutaFichero);
    var nombreFichero = url.pathname;
    return getNombreFicheroSinExtension(nombreFichero)!;
}

</script>
<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";

.sucesos-pestana ::v-deep(.dx-tabs-expanded .dx-tab) {
    flex-basis: auto;
}

.no-ficheros {
    padding-top: var(--spacing-md);
    display: block;
    font-size: var(--font-size-body-lg);
    color: var(--text-primary-default);
}

.dx-viewport:not(.dx-theme-generic) .dx-tabs-horizontal {
    border-block-end: 1px solid var(--border-default-default);
}
</style>